import React, { useEffect } from "react";

// components
import {
  Button,
  FormGroup,  
  Input,  
  Modal,
  Row,
  Col ,  
} from "reactstrap";

// helpers
import {formateDateandTime} from "../../../helpers/formats.js";


export default function ModalDetalhesInconformidade({stateModalDetalhesInconformidade, item, handleReturn }) {
    
    const [stateModal, setstateModal] = React.useState(stateModalDetalhesInconformidade);

    useEffect(() => {         
        setstateModal(stateModalDetalhesInconformidade);
    }, [stateModalDetalhesInconformidade]);
            
    const Return = () => {          
        handleReturn();
    }

    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"                
            >     
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                        Detalhes da {item?.categoria ?? "Inconformidade"}
                    </h4>
                    <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"   
                    onClick={() => handleReturn()}                 
                    >
                    <span aria-hidden={true}>×</span>
                    </button>
                </div>           
                <div className="modal-body">                                           
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Data/Hora
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="categoria"                                    
                                    type="text"
                                    value={item != null && formateDateandTime(item.dataHoraInconsistencia)}
                                    disabled="true"
                                />                                
                            </FormGroup>
                        </Col>    
                        <Col md="4">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Situação
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="situacao"                                    
                                    type="text"
                                    value={item != null && item.situacao}
                                    disabled="true"
                                />                                
                            </FormGroup>
                        </Col>                        
                        <Col md="4">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Inconformidade
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="descricao"                                    
                                    type="text"
                                    value={item != null && item.tipoInconsistencia}
                                    disabled="true"
                                />                                
                            </FormGroup>
                        </Col>                        
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Dados Adicionais
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="descricao"                                    
                                    type="text"
                                    value={item != null && item.dadosAdicionais}
                                    disabled="true"
                                />                                
                            </FormGroup>
                        </Col>                                                                   
                    </Row>                            
                </div>
                <div className="modal-footer">               
                <Button color="secondary" type="button" onClick={() => Return()}>
                    Fechar
                </Button>                              
                </div>
            </Modal>
        </>
    );  
}
